(() => {
  class FurnitureVideoStory extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.video = this.querySelector('video') || this.querySelector('[data-fvs-video]');
      this.toggle = this.querySelector('[data-fvs-toggle]');
      if (!this.video || !this.toggle) return;

      // Ensure muted autoplay works across browsers
      this.video.muted = true;
      this.video.playsInline = true;

      this.toggle.addEventListener('click', () => {
        if (this.video.paused) {
          this.video.play();
          this.toggle.classList.add('is-playing');
          this.toggle.setAttribute('aria-label', 'Pause video');
        } else {
          this.video.pause();
          this.toggle.classList.remove('is-playing');
          this.toggle.setAttribute('aria-label', 'Play video');
        }
      });
    }
  }

  if (!customElements.get('furniture-video-story')) {
    // Section root is <section class="fvs">, so enhance by query on load
  }

  document.querySelectorAll('[data-fvs]').forEach((el) => {
    if (el._fvsBound) return;
    el._fvsBound = true;
    const video = el.querySelector('video');
    const toggle = el.querySelector('[data-fvs-toggle]');
    if (!video || !toggle) return;
    video.muted = true;
    toggle.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        toggle.classList.add('is-playing');
        toggle.setAttribute('aria-label', 'Pause video');
      } else {
        video.pause();
        toggle.classList.remove('is-playing');
        toggle.setAttribute('aria-label', 'Play video');
      }
    });
  });
})();
